import { render, staticRenderFns } from "./SubjectDetail3.vue?vue&type=template&id=156a288c&scoped=true&"
import script from "./SubjectDetail3.vue?vue&type=script&lang=js&"
export * from "./SubjectDetail3.vue?vue&type=script&lang=js&"
import style0 from "./SubjectDetail3.vue?vue&type=style&index=0&id=156a288c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156a288c",
  null
  
)

export default component.exports